import React, { Component } from 'react';
import '../css/FundDetails.css';
import Popup from 'reactjs-popup';
import FundReturns from './FundReturns';
import * as CurrencyFormat from 'react-currency-format';

class FundDetails extends Component {
    constructor(props) {
        super(props)
        this.state = {
            selectedAccount: "-1",
            selectedFund: "-1",
            clicked: "next",
            prevClickCount: 0,
            nextClickCount: 0,
            accountsChecked: [],
            fundsChecked: [],
            openAccountsPopup: false,
            openFundsPopup: false,
            totalFunds: [],
            fundBalances: []
        }
        this.makeAccountsArray = this.makeAccountsArray.bind(this);
        this.makeAccsFromFunds = this.makeAccsFromFunds.bind(this);
        this.displayFunds = this.displayFunds.bind(this);
        this.filterFundsByAccounts = this.filterFundsByAccounts.bind(this);
        this.filterFundsByfunds = this.filterFundsByfunds.bind(this)
        this.handleAccounts = this.handleAccounts.bind(this);
        this.handleFunds = this.handleFunds.bind(this);
        this.handlePrevious = this.handlePrevious.bind(this);
        this.handleNext = this.handleNext.bind(this)
    }

    static getDerivedStateFromProps(props, state) {
        let fundBalances = [];
        props.fundBalances && props.fundBalances.map(fundBalance => fundBalances.push(fundBalance))

        return {
            totalFunds: props.totalFunds,
            fundBalances: fundBalances
        }
    }


    /**
     * returns an array of accounts to create radio buttons.
     */
    makeAccountsArray() {
        const accountsArray = []
        if (this.props.products) {
            this.props.products.map(product => {
                if (product.accounts.length !== 0) {
                    product.accounts.map(account =>
                        accountsArray.push(account))
                }
            })
        }
        return accountsArray;
    }

    /**
     * returns an array of funds to create columns
     */
    makeAccsFromFunds() {
        let fundBalances = []
        let funds = []
        if (this.state.fundBalances) {
            fundBalances = Object.keys(this.state.fundBalances).map(key => this.state.fundBalances[key])
            funds = fundBalances.length === 0 ? " " : fundBalances[0].funds;
        }
        return funds;
    }
    /**Displays funds on prev and next button clicks.
     * 4 columns of funds are displayed on each click
     */
    displayFunds(buttonClick) {
        let displayFunds = []
        let i = 0;
        const makeAccsFromFunds = this.makeAccsFromFunds()
        if (makeAccsFromFunds.length < 4) {
            displayFunds = !makeAccsFromFunds ? "" : makeAccsFromFunds
        }
        else {
            if (buttonClick === "prev") {
                i = this.state.prevClickCount;
                if (makeAccsFromFunds.length > this.state.prevClickCount) {
                    while (i < makeAccsFromFunds.length && i <= this.state.prevClickCount + 3) {
                        if (this.state.prevClickCount === 0) {
                            while (i <= this.state.prevClickCount + 3) {
                                displayFunds.push(makeAccsFromFunds[i]);
                                i++;
                            }
                            /**Enable the following code if you want the 'previous' button to be disabled
                             * once it reaches the first fund in the table.
                             */
                            // if(i===4){
                            //     document.getElementById("prev").disabled = true;
                            // }
                        }
                        else {
                            document.getElementById("prev").disabled = false;
                            displayFunds.push(makeAccsFromFunds[i]);
                            i++;
                        }
                    }
                }
                if (i >= makeAccsFromFunds.length) {
                    i = 0;
                    while (i < 4 - (makeAccsFromFunds.length - this.state.prevClickCount)) {
                        displayFunds.push(makeAccsFromFunds[i]);
                        i++;
                    }
                }
            }
            else if (buttonClick === "next") {
                i = this.state.nextClickCount;
                if (makeAccsFromFunds.length >= this.state.nextClickCount + 4) {
                    while (i < this.state.nextClickCount + 4 && i !== makeAccsFromFunds.length) {
                        displayFunds.push(makeAccsFromFunds[i]);
                        i++;
                    }
                }
                else {
                    if (this.state.nextClickCount < makeAccsFromFunds.length) {
                        if (makeAccsFromFunds.length < this.state.nextClickCount + 4) {
                            while (i < makeAccsFromFunds.length) {
                                displayFunds.push(makeAccsFromFunds[i]);
                                i++;
                            }
                            if (i >= makeAccsFromFunds.length) {
                                i = 0;
                                while (i < 4 - (makeAccsFromFunds.length - this.state.nextClickCount)) {
                                    displayFunds.push(makeAccsFromFunds[i]);
                                    i++;
                                }
                            }
                        }
                    }
                }
            }
        }
        return displayFunds
    }

    /**Event Handler for Previous Button */
    handlePrevious(e) {
        document.getElementById("next").disabled = false;
        if (this.state.prevClickCount === 0)
            this.setState({
                clicked: "prev",
                prevClickCount: this.makeAccsFromFunds().length - 1,
                nextClickCount: 0
            })
        else
            this.setState({
                clicked: "prev",
                nextClickCount: this.state.nextClickCount > 0 ? this.state.nextClickCount - 1 : this.state.prevClickCount,
                prevClickCount: this.state.prevClickCount - 1,
            })

        this.displayFunds("prev")
    }

    /**Event Handler for Next Button */
    handleNext(e) {
        document.getElementById("prev").disabled = false

        if ((this.state.nextClickCount >= this.makeAccsFromFunds().length - 1 && this.state.prevClickCount >= this.makeAccsFromFunds().length - 1)
            || (this.state.prevClickCount === this.makeAccsFromFunds().length - 1 && this.state.nextClickCount === 0)) {
            this.setState({
                clicked: "next",
                prevClickCount: 0,
                nextClickCount: 0
            })
        }
        else if (this.state.nextClickCount > this.state.prevClickCount) {
            this.setState({
                clicked: "next",
                prevClickCount: this.state.prevClickCount + 1,
                nextClickCount: this.state.nextClickCount
            })
        }
        else {
            this.setState({
                clicked: "next",
                prevClickCount: this.state.prevClickCount + 1,
                nextClickCount: this.state.prevClickCount === 0 && this.state.nextClickCount === 1 ? 1 : this.state.nextClickCount + 1
            })
        }
        this.displayFunds("next")
    }

    /**Event Handler to filter funds by accounts choosen*/
    filterFundsByAccounts(e) {
        let accountsCheckbox = document.getElementsByName("accountsCheckbox")
        let accountsChecked = []
        if (accountsCheckbox.length !== 0) {
            for (let value of accountsCheckbox.values()) {
                if (value.checked)
                    accountsChecked.push(value.id)
            }
            this.setState({ accountsChecked: accountsChecked })
        }
        else
            this.setState({ accountsChecked: this.state.accountsChecked })
    }

    /**Boolean method, returns true or false to checked attribute of 
     * input type checkbox to check or uncheck the accounts
     * and return funds with respect to the choosen accounts
     */
    accountsChecked(accountCode) {
        if (this.state.accountsChecked.length === 0)
            return true;
        else if (this.state.accountsChecked.filter(accountChecked => accountChecked === accountCode).length === 1)
            return true;
        else
            return false;
    }

    /**Event Handler to filter funds by funds choosen */
    filterFundsByfunds(e) {
        let fundsCheckbox = document.getElementsByName("fundsCheckbox");
        let fundsChecked = []
        if (fundsCheckbox.length !== 0) {
            for (let value of fundsCheckbox.values()) {
                if (value.checked)
                    fundsChecked.push(value.id)
            }
            this.setState({ fundsChecked: fundsChecked })
        }
        else
            this.setState({ fundsChecked: this.state.fundsChecked })
    }

    filterFunds(e) {
        if (e.target.id === "byFunds")
            this.props.filterFundsByFunds(this.state.fundsChecked.join())
        else if (e.target.id === "byAccounts")
            this.props.filterFundsByAccounts(this.state.accountsChecked.join())
        this.setState({ openAccountsPopup: false, openFundsPopup: false })
    }
    /**Boolean method returns true of false to checked attribute of
     * input type checkbox to check or uncheck the funds and returns
     * funds with respect to the choosen funds
     */
    fundsChecked(fundCode) {
        if (this.state.fundsChecked.length === 0)
            return true;
        else if (this.state.fundsChecked.filter(fund => fund === fundCode).length === 1)
            return true;
        else
            return false;
    }

    /**Event Handler for Accounts Radio Buttons */
    handleAccounts(e) {
        this.setState({ selectedAccount: e.target.value })
        let accountsArray = document.getElementsByClassName("accountsArray");
        for (let item of accountsArray) {
            if (item.id === e.target.id)
                item.checked = true;
            else
                item.checked = false;
        }
        if (e.target.id !== "chooseAccounts") {
            this.props.filterFundsByAccounts(e.target.id)

        }
        else {
            this.setState({ openAccountsPopup: true })
            this.filterFundsByAccounts(e)

        }
    }

    /**Event Handler for Funds Radio Buttons */
    handleFunds(e) {
        this.setState({ selectedFund: e.target.value, openFundsPopup: true })
        let fundsArray = document.getElementsByClassName("fundsArray");
        for (let item of fundsArray) {
            if (item.id === e.target.id)
                item.checked = true;
            else
                item.checked = false;
        }
    }

    render() {
        const makeAccsFromFunds = this.makeAccsFromFunds()
        const { t } = this.props
        return (
            this.props.isFundBalancesEmpty ? <div className="tabMessage">There are no transactions for the period chosen</div> :
                !this.state.fundBalances || this.state.fundBalances.length === 0 ? <div className="tabMessage">{t('fetching') + " " + t('fund') + " " + t('balances')}...</div> :
            <div
            // style={{marginLeft: "12px"}}
            >
                <table style={{
                    border: "1px solid rgb(217, 217, 217)",
                    borderTop: "none", borderBottom: "none", width: "99.9%", fontSize: "12px"
                }}>
                    <tbody>
                        <tr>
                            <td style={{ fontWeight: "bold" }}>{t('memberDetails:accounts')}</td>
                            <td><input className="accountsArray" type="radio" id="allAccounts" value="-1" defaultChecked="true"
                                onChange={e => this.handleAccounts(e)} />{t('balanceDetails:all')}</td>
                            <Popup trigger={<td><input className="accountsArray" type="radio" id="chooseAccounts" value="-2"
                                onChange={e => this.handleAccounts(e)}
                                onClick={e => this.handleAccounts(e)} />{t('balanceDetails:chooseAccounts')}</td>}
                                open={this.state.openAccountsPopup}
                                position="right center">
                                <div>
                                    {
                                        !this.makeAccountsArray() ? "Fetcthing Accounts" :
                                            this.makeAccountsArray().map(account =>
                                                <div><input name="accountsCheckbox" type="checkbox" id={account.code}
                                                    checked={this.accountsChecked(account.code)}
                                                    onChange={e => this.filterFundsByAccounts(e)} />
                                                    <label>{account.account}</label>                                                </div>)
                                    }
                                    <table>
                                        <td><button id="byAccounts" onClick={e => this.filterFunds(e)}>{t('balanceDetails:ok')}</button></td>
                                        <td><button id="byAccounts" onClick={e => this.setState({ openAccountsPopup: false })}>{t('balanceDetails:cancel')}</button></td>
                                    </table>
                                </div>
                            </Popup>
                        </tr>
                        <tr>
                            <td style={{ fontWeight: "bold" }}>{t('memberDetails:funds')}</td>
                            <td><input className="fundsArray" type="radio" id="allFunds" value="-1" defaultChecked="true"
                                onClick={e => this.handleFunds(e)} />{t('balanceDetails:all')}</td>
                            <Popup trigger={<td><input className="fundsArray" type="radio" id="chooseFunds" value="0"
                                onClick={e => this.handleFunds(e)} />{t('balanceDetails:chooseFunds')}</td>}
                                open={this.state.openFundsPopup}>
                                <div>
                                    {
                                        
                                        // !this.state.fundBalances  ? "Fetching Funds" : this.state.fundBalances.length <= 0 ?
                                        //     "No Funds" : !this.state.totalFunds ? "Fetching Funds" :
                                        // this.state.totalFunds.length <= 0 ? "No Funds" :
                                        this.props.isFundBalancesEmpty ? <div> No Funds </div> : 
                                        !this.state.fundBalances || this.state.fundBalances.length == 0 ? <div>Fetching fund Balances</div> :
                                            this.state.totalFunds.map(funds =>
                                                <div><input name="fundsCheckbox" type="checkbox" id={funds.code}
                                                    checked={this.fundsChecked(funds.code)}
                                                    onChange={e => this.filterFundsByfunds(e)} />
                                                    <label>{funds.description}</label></div>)}
                                    <table>
                                        <td><button id="byFunds" onClick={(e) => this.filterFunds(e)}>OK</button></td>
                                        <td><button onClick={() => this.setState({ openFundsPopup: false })}>Cancel</button></td>
                                    </table>
                                </div>
                            </Popup>
                        </tr>
                        <tr>
                            <td></td>
                            <td></td>
                            <td>
                                <button className="fundDetails" id="prev" style={{ alignSelf: "center" }} onClick={e => this.handlePrevious(e)} hidden={makeAccsFromFunds.length <= 4}> &lt;&lt;{t('balanceDetails:previous')}</button>
                            </td>
                            <td>
                                <button className="fundDetails" id="next" style={{ alignSelf: "center" }} onClick={e => this.handleNext(e)} hidden={makeAccsFromFunds.length <= 4}> {t('balanceDetails:next')}&gt;&gt; </button>
                            </td>
                        </tr>
                    </tbody>
                </table>
                
                <table id="FundDetailsTab" className="table-responsive superlifeLegacyPlan accounts-funds" style={{ marginLeft: "-1px", marginRight: "1px" }}>
                    <thead>
                        <th style={{ height: 30 }}></th>
                        {
                            !this.state.fundBalances || this.state.fundBalances.length <= 0 ? "" : !this.displayFunds(this.state.clicked) ? "" :
                                this.displayFunds(this.state.clicked).map(funds => <th>{funds ? funds.fund : ""}</th>)
                        }
                        <th>{t('balanceDetails:totalFunds')}</th>
                    </thead>


                    <tbody>
                        {
                            !this.state.fundBalances ? <div className="tabMessage">{t('fetching') + " " + t('fund') + " " + t('balances')}...</div> :
                                this.state.fundBalances.length <= 0 ? <div className="tabMessage">{t('no') + " " + t('funds')}....</div> : this.state.fundBalances.map((fundBalance, index) =>
                                    <tr key={index}>
                                        <td style={{
                                            textAlign: "left", fontWeight: (fundBalance.balanceType === "opening" ||
                                                fundBalance.balanceType === "closing") && "bold"
                                        }}>{(fundBalance.description && fundBalance.description.includes("PIR") && this.props.member.pirRate)?
                                        fundBalance.description + " (PIR:"+this.props.member.pirRate+"%)" : fundBalance.description}</td>
                                        {
                                            this.state.clicked === "next" ? !fundBalance.funds ? " " : fundBalance.funds.length > 4 ?
                                                this.state.nextClickCount + 4 <= makeAccsFromFunds.length ?
                                                    fundBalance.funds.slice(this.state.nextClickCount, this.state.nextClickCount + 4)
                                                        .map(fund => <td>{fund.amount === 0 ? "-" :
                                                            <CurrencyFormat value={Number(fund.amount).toFixed(2)}
                                                                displayType={'text'}
                                                                thousandSeparator={true}
                                                                prefix={'$'} />}</td>) :
                                                    fundBalance.funds.slice(this.state.nextClickCount, makeAccsFromFunds.length)
                                                        .concat(fundBalance.funds.slice(0, 4 - (makeAccsFromFunds.length - this.state.nextClickCount)))
                                                        .map(fund => <td>{fund.amount === 0 ? "-" :
                                                            <CurrencyFormat value={Number(fund.amount).toFixed(2)}
                                                                displayType={'text'}
                                                                thousandSeparator={true}
                                                                prefix={'$'} />}</td>) :
                                                fundBalance.funds.map(fund => <td>{fund.amount === 0 ? "-" :
                                                    <CurrencyFormat value={Number(fund.amount).toFixed(2)}
                                                        displayType={'text'}
                                                        thousandSeparator={true}
                                                        prefix={'$'} />}</td>) :

                                                this.state.clicked === "prev" ? !fundBalance.funds ? " " : fundBalance.funds.length > 4 ?
                                                    this.state.prevClickCount + 4 >= makeAccsFromFunds.length ?
                                                        fundBalance.funds.slice(this.state.prevClickCount, makeAccsFromFunds.length)
                                                            .concat(fundBalance.funds.slice(0, 4 - (makeAccsFromFunds.length - this.state.prevClickCount)))
                                                            .map(fund => <td>{fund.amount === 0 ? "-" :
                                                                <CurrencyFormat value={Number(fund.amount).toFixed(2)}
                                                                    displayType={'text'}
                                                                    thousandSeparator={true}
                                                                    prefix={'$'} />}</td>) :
                                                        fundBalance.funds.slice(this.state.prevClickCount, this.state.prevClickCount + 4).map(fund =>
                                                            <td>{fund.amout === 0 ? "-" :
                                                                <CurrencyFormat value={Number(fund.amount).toFixed(2)}
                                                                    displayType={'text'}
                                                                    thousandSeparator={true}
                                                                    prefix={'$'} />}</td>) :
                                                    fundBalance.funds.slice(0, fundBalance.funds.length).map(fund =>
                                                        <td>{fund.amount === 0 ? "-" :
                                                            <CurrencyFormat value={Number(fund.amount).toFixed(2)}
                                                                displayType={'text'}
                                                                thousandSeparator={true}
                                                                prefix={'$'} />}</td>) : ""
                                        }
                                        <td><CurrencyFormat value={Number(fundBalance.totalAmt).toFixed(2)}
                                            displayType={'text'}
                                            thousandSeparator={true}
                                            prefix={'$'} /></td>
                                    </tr>)
                        }
                    </tbody>
                </table>
                <table>
                    <tbody>
                        <tr style={{ fontSize: "12px", textAlign: "top", }}>{t("AccountBalance:SubjectTo")}</tr>
                    </tbody>
                </table>
                <table style={{ marginTop: "10px" }}>
                    <tbody>
                        <tr style={{ fontSize: "12px", textAlign: "top", marginTop: "12px" }}>{t("AccountBalance:TheEmployerContributions")}</tr>
                    </tbody>
                </table>
                <table style={{ marginTop: "10px" }}>
                    <tbody>
                        <tr style={{ fontSize: "12px", textAlign: "top", marginTop: "12px" }}>{t("AccountBalance:TheTotalFunds")}</tr>
                    </tbody>
                </table>
                <table style={{ marginTop: "10px" }}>
                    <tbody>
                        <tr style={{ fontSize: "12px", textAlign: "top", marginTop: "12px" }}>{t("AccountBalance:NoteTheEmployerContributions")}</tr>
                    </tbody>
                </table>
                <FundReturns {...this.props}
                    displayHeaders={this.displayFunds(this.state.clicked)}
                    totalHeaders={this.makeAccsFromFunds()}
                    nextClickCount={this.state.nextClickCount}
                    prevClickCount={this.state.prevClickCount}
                    clicked={this.state.clicked} />
            </div>
        )
    }
}

export default FundDetails